function Filemanager_choose_document(element) {
  this.$element = $(element);
  this.popup = i4_Popup.get(this.$element);

  this.selectors = {
    filterDecorator: '.js-filter-decorator',
    listItem: '.js-list-item',
    buttonCancel: '.js-button-cancel',
    buttonChoose: '.js-button-choose',
    containerPreview: '.js-container-preview-choose',
    selected: '.selected'
  };

  this.classNames = {
    containerPreview: 'js-container-preview-choose',
    selected: 'selected'
  };

  this.data = {
    targetFieldId: 'target-field-id'
  };

  this.triggers = {
    afterFiltered: 'i4:afterFiltered'
  };

  this.init = function () {
    this.$buttonCancel = this.$element.find(this.selectors.buttonCancel);
    this.$buttonChoose = this.$element.find(this.selectors.buttonChoose);
    this.$filterDecorator = this.$element.find(this.selectors.filterDecorator);
    this.$listItem = this.$element.find(this.selectors.listItem);

    this.dataTargetFieldId = this.$element.data(this.data.targetFieldId);
    this.$targetField = $('#' + this.dataTargetFieldId);
    this.$containerPreview = this.$targetField.next(this.selectors.containerPreview);

    this.$buttonCancel.on('click', this.$onClickCancel.bind(this));
    this.$buttonChoose.on('click', this.$onClickChoose.bind(this));
    this.$filterDecorator.on(this.triggers.afterFiltered, this.afterFiltered.bind(this));

    this.$buttonChoose.addClass('invalid');

    if (!this.$containerPreview.length) {
      this.$containerPreview = $('<div></div>').addClass(this.classNames.containerPreview);
      this.$targetField.after(this.$containerPreview);
    }
  };

  this.$onClickCancel = function () {
    this.closePopup();
  };

  this.$onClickChoose = function () {
    if (!this.$buttonChoose.hasClass('invalid')) {
      this.choose();
    }
  };

  this.closePopup = function () {
    var parentPopup = i4_Popup.get(this.dataTargetFieldId);

    if (parentPopup) {
      parentPopup.show();
    }

    this.popup.remove();
  };

  this.choose = function () {
    var selected = this.$element.find(this.selectors.selected);

    this.$targetField.val(selected.data('filemanager-id'));
    this.$containerPreview.html(selected.find('div').html());

    this.closePopup();

    this.$targetField.trigger('i4:choose');
    this.$targetField.trigger('i4:choose-complete');
  };

  this.afterFiltered = function () {
    this.$listItem = this.$element.find(this.selectors.listItem);
    this.$listItem.each((function (i, item) {
      $(item).on('click', (function () {
        this.$listItem.removeClass(this.classNames.selected);
        $(item).addClass(this.classNames.selected);

        this.$buttonChoose.removeClass('invalid');
      }).bind(this));

      $(item).on('dblclick', (function () {
        this.choose();
      }).bind(this));
    }).bind(this));
  };
}
